import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34606071"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-home" }
const _hoisted_2 = {
  id: "profile",
  class: "mobile-hero"
}
const _hoisted_3 = { class: "mobile-hero__tag" }
const _hoisted_4 = { class: "mobile-section mobile-work-profile" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "mobile-section__header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Arbeitsprofil"),
  /*#__PURE__*/_createElementVNode("h2", null, "Wie ich Verantwortung übernehme."),
  /*#__PURE__*/_createElementVNode("p", null, " Entwicklungserfahrung bleibt die Grundlage. Der Schwerpunkt liegt heute in Analyse, Aufbau, Softwarearchitektur, KI/RAG und Führung. ")
], -1))
const _hoisted_6 = { class: "mobile-flow" }
const _hoisted_7 = {
  id: "expertise",
  class: "mobile-section mobile-expertise"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "mobile-section__header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expertise"),
  /*#__PURE__*/_createElementVNode("h2", null, "Womit ich diese Rolle fülle."),
  /*#__PURE__*/_createElementVNode("p", null, " Die einzelnen Fähigkeiten sind wichtig. Entscheidend ist ihr Zusammenspiel aus Produkt, Softwarearchitektur, KI/RAG und operativer Klarheit. ")
], -1))
const _hoisted_9 = { class: "mobile-accordion-list" }
const _hoisted_10 = ["aria-expanded", "onClick"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mobile-section mobile-ai" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "mobile-section__header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "KI & RAG"),
  /*#__PURE__*/_createElementVNode("h2", null, "Wissenssysteme, die im Alltag tragen."),
  /*#__PURE__*/_createElementVNode("p", null, " RAG ist Architekturarbeit: Daten vorbereiten, Suche bewerten, Kontext steuern, Antworten belegen und Grenzen sichtbar halten. ")
], -1))
const _hoisted_14 = { class: "mobile-ai__cards" }
const _hoisted_15 = { class: "mobile-section mobile-modes" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "mobile-section__header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Anknüpfung"),
  /*#__PURE__*/_createElementVNode("h2", null, "Wo ein Gespräch sinnvoll ist.")
], -1))
const _hoisted_17 = { class: "mobile-card-list" }
const _hoisted_18 = { class: "mobile-section mobile-evidence" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "mobile-section__header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Praxis"),
  /*#__PURE__*/_createElementVNode("h2", null, "Wo diese Arbeitsweise praktisch wird.")
], -1))
const _hoisted_20 = { class: "mobile-evidence__timeline" }
const _hoisted_21 = {
  id: "contact",
  class: "mobile-section mobile-contact"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "mobile-section__header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nächster Schritt"),
  /*#__PURE__*/_createElementVNode("h2", null, " Wenn es um Softwarearchitektur, technische Leitung oder Vecura geht, lass uns sprechen. "),
  /*#__PURE__*/_createElementVNode("p", null, " E-Mail ist der direkte Weg für konkrete Anfragen. LinkedIn nutze ich für beruflichen Kontext und Austausch. Alles rund um Vecura läuft über vecura.io oder hello@vecura.io. ")
], -1))
const _hoisted_23 = { class: "mobile-contact__person" }
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Timo Rothdeutsch"),
  /*#__PURE__*/_createElementVNode("span", null, "Mitgründer & COO bei Vecura"),
  /*#__PURE__*/_createElementVNode("small", null, " Softwarearchitektur, KI/RAG und technische Verantwortung. ")
], -1))
const _hoisted_26 = {
  class: "mobile-contact__actions",
  "aria-label": "Kontaktwege"
}
const _hoisted_27 = ["href", "target", "rel", "aria-label"]

import { ref } from "vue";
import ContactChannelIcon from "@/components/icons/ContactChannelIcon.vue";
import MobileSymbolIcon from "@/components/icons/MobileSymbolIcon.vue";
import contactPortrait from "@/assets/timo-contact-portrait.jpg";
import {
  aiExpertiseItems,
  contactChannels,
  evidenceItems,
  expertisePillars,
  heroFocusItems,
  profile,
  workModes,
} from "@/data/profile";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileHomePage',
  setup(__props) {

const openPillarTitles = ref<Set<string>>(
  new Set(expertisePillars[0] ? [expertisePillars[0].title] : [])
);

function getPillarIcon(
  index: number
): "briefcase" | "compass" | "brain" | "shield" {
  const icons = ["briefcase", "compass", "brain", "shield"] as const;
  return icons[index] ?? "briefcase";
}

function getChannelIcon(label: string): "mail" | "linkedin" | "vecura" {
  const normalizedLabel = label.toLowerCase();

  if (normalizedLabel.includes("mail")) {
    return "mail";
  }

  if (normalizedLabel.includes("linkedin")) {
    return "linkedin";
  }

  return "vecura";
}

function isExternalLink(href: string): boolean {
  return href.startsWith("http");
}

function isPillarOpen(title: string): boolean {
  return openPillarTitles.value.has(title);
}

function togglePillar(title: string): void {
  const nextOpenTitles = new Set(openPillarTitles.value);

  if (nextOpenTitles.has(title)) {
    nextOpenTitles.delete(title);
  } else {
    nextOpenTitles.add(title);
  }

  openPillarTitles.value = nextOpenTitles;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref(profile).headline), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(MobileSymbolIcon, { type: "compass" }),
        _createElementVNode("span", null, _toDisplayString(_unref(profile).roleLine), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(_unref(profile).intro), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(heroFocusItems), (item, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.title
          }, [
            _createElementVNode("small", null, _toDisplayString(String(index + 1).padStart(2, "0")), 1),
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(item.title), 1),
              _createElementVNode("p", null, _toDisplayString(item.detail), 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(expertisePillars), (pillar, index) => {
          return (_openBlock(), _createElementBlock("article", {
            key: pillar.title,
            class: _normalizeClass(["mobile-accordion", { 'mobile-accordion--open': isPillarOpen(pillar.title) }])
          }, [
            _createElementVNode("button", {
              class: "mobile-accordion__summary",
              type: "button",
              "aria-expanded": isPillarOpen(pillar.title),
              onClick: ($event: any) => (togglePillar(pillar.title))
            }, [
              _createVNode(MobileSymbolIcon, {
                type: getPillarIcon(index)
              }, null, 8, ["type"]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(pillar.title), 1),
                _createElementVNode("span", null, _toDisplayString(pillar.summary), 1)
              ])
            ], 8, _hoisted_10),
            _createVNode(_Transition, { name: "mobile-disclosure" }, {
              default: _withCtx(() => [
                (isPillarOpen(pillar.title))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pillar.points, (point) => {
                        return (_openBlock(), _createElementBlock("li", { key: point }, _toDisplayString(point), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(aiExpertiseItems), (item) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.title
          }, [
            _createVNode(MobileSymbolIcon, { type: "brain" }),
            _createElementVNode("h3", null, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, _toDisplayString(item.description), 1),
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.methods, (method) => {
                return (_openBlock(), _createElementBlock("span", { key: method }, _toDisplayString(method), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workModes), (mode) => {
          return (_openBlock(), _createElementBlock("article", {
            key: mode.title
          }, [
            _createElementVNode("small", null, _toDisplayString(mode.status), 1),
            _createElementVNode("strong", null, _toDisplayString(mode.title), 1),
            _createElementVNode("p", null, _toDisplayString(mode.description), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(evidenceItems), (item) => {
          return (_openBlock(), _createElementBlock("article", {
            key: item.title
          }, [
            _createElementVNode("small", null, _toDisplayString(item.label), 1),
            _createElementVNode("h3", null, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, _toDisplayString(item.context), 1),
            _createElementVNode("strong", null, _toDisplayString(item.outcome), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("section", _hoisted_21, [
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("figure", null, [
          _createElementVNode("img", {
            src: _unref(contactPortrait),
            alt: "Portrait von Timo Rothdeutsch",
            loading: "lazy",
            decoding: "async"
          }, null, 8, _hoisted_24)
        ]),
        _hoisted_25
      ]),
      _createElementVNode("div", _hoisted_26, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contactChannels), (channel) => {
          return (_openBlock(), _createElementBlock("a", {
            key: channel.href,
            class: "mobile-contact-action",
            href: channel.href,
            target: isExternalLink(channel.href) ? '_blank' : undefined,
            rel: 
            isExternalLink(channel.href) ? 'noopener noreferrer' : undefined
          ,
            "aria-label": `${channel.label}: ${channel.value}`
          }, [
            _createVNode(ContactChannelIcon, {
              class: "mobile-contact-action__icon",
              type: getChannelIcon(channel.label)
            }, null, 8, ["type"])
          ], 8, _hoisted_27))
        }), 128))
      ])
    ])
  ]))
}
}

})